export function getBgColor(variant: string = 'white'): string {
  switch (variant) {
    case 'red':
      return 'bg-background-red'
    case 'blue':
      return 'bg-background-blue'
    case 'green':
      return 'bg-background-green'
    case 'yellow':
      return 'bg-background-yellow'
    case 'lavendel':
      return 'bg-background-lavendel'
    case 'gray':
      return 'bg-background-grey'
    case 'white':
    default:
      return ''
  }
}
